<template>
  <div class="default-layout-container">
    <div class="content-container-1140">
      <h1>{{ pageContent.data[0].attributes.PageTitle }}</h1>
      <div class="main-content">
        <div
          class="page-content md-content"
          v-html="md.render(pageContent.data[0].attributes.PageContentHTML)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { locale } = useI18n();
const { md } = useMarkdownIt();
const localeRoute = useLocaleRoute();
const route = useRoute();

// api content
const contentType = "case-studies";
const key = `${contentType}_${locale.value}`;
const apiURL = getStrapiLink(contentType, {
  fields: ["PageTitle", "PageURL", "Summary", "PageContentHTML"],
  populate: ["FeatureImage"],
  filters: { PageURL: { $eqi: route.params.CaseStudyURL } },
});
const { data: pageContent, pending: apiPending } = await useFetch(apiURL, {
  key: key,
  watch: false,
});

useHead({
  title: () => pageContent.value?.data[0]?.attributes?.PageTitle
})
</script>
<style lang="scss" scoped></style>
